import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "../components/SectionHeading";
import SEO from "../components/SEO";

const CARDS = [
  { t: "Your consultation", d: "£300 for a 1-hour new consultation with your consultant. Follow-up consultations are £150 in person or £125 by telephone for patients the clinic has already seen, booked from your secure patient account. We see self-pay patients only." },
  { t: "Tests and scans", d: "You can add tests such as an ECG, echocardiogram or blood pressure monitoring when you book - the full price, including any tests, is shown before you pay before you pay. If we recommend anything else once we’ve seen you, we’ll give you the cost in writing first. Tests done at Cambridge University Hospitals are billed directly by the Trust at their published rates." },
];

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <SEO title="Fees" description="Fees at Cambridge Cardiovascular Prevention Clinic: £300 for a 1-hour new consultation. Tests can be added when you book, and the full price is shown before you pay." path="/pricing" />
      <section className="bg-cream-100 border-b border-bronze-light/30">
        <div className="container-ccc py-20 max-w-4xl">
          <div className="eyebrow">Fees</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
            <em className="font-serif text-bronze-dark">No surprises.</em> Clear fees.
          </h1>
          <p className="mt-6 text-ink-muted text-lg leading-relaxed max-w-2xl">
            We are a self-pay clinic — we don’t accept private medical insurance. Your first step is a consultation. Every patient is different, so we can only recommend tests once we’ve seen you — and we’ll tell you what they cost before anything goes ahead.
          </p>
          <Link to="/enquiry" data-testid="pricing-book-cta" className="btn-primary mt-8 inline-flex">Book a consultation</Link>
        </div>
      </section>

      <section className="container-ccc py-20 grid md:grid-cols-2 gap-6">
        {CARDS.map((b) => (
          <div key={b.t} data-testid={`pricing-card-${b.t.split(" ")[0].toLowerCase()}`} className="p-8 bg-white border border-stone-200/60 rounded-md">
            <h3 className="font-serif text-2xl">{b.t}</h3>
            <p className="mt-3 text-ink-muted text-sm leading-relaxed">{b.d}</p>
          </div>
        ))}
      </section>

      <section className="container-ccc pb-20 text-center">
        <SectionHeading center title="Any questions about fees?" subtitle="Send us a message and we will be back with you shortly." />
        <div className="mt-10">
          <Link data-testid="pricing-contact-cta" to="/contact" className="btn-secondary">Contact us</Link>
        </div>
      </section>
    </div>
  );
}
